export const CLIENT = `CLIENT`;

export const GET_CLIENT_LIST_DATA = `${CLIENT}/GET_CLIENT_LIST_DATA`;
export const SET_CLIENT_LIST_DATA = `${CLIENT}/SET_CLIENT_LIST_DATA`;
export const SET_NOTE_CLIENT_DATA = `${CLIENT}/SET_NOTE_CLIENT_DATA`;
export const GET_CLIENT_DETAIL_DATA = `${CLIENT}/GET_CLIENT_DETAIL_DATA`;
export const SET_CLIENT_DETAIL_DATA = `${CLIENT}/SET_CLIENT_DETAIL_DATA`;
export const GET_CLIENT_DETAILS_PAGINATOR = `${CLIENT}/GET_CLIENT_DETAILS_PAGINATOR`;
export const SET_CLIENT_DETAILS_PAGINATOR = `${CLIENT}/SET_CLIENT_DETAILS_PAGINATOR`;

export const SET_CLIENT_CARE_ACTIVITY_SELECTED_ITEMS = `${CLIENT}/SET_CLIENT_CARE_ACTIVITY_SELECTED_ITEMS`;
